<template>
  <div class="config_main_manage_background">
    <!-- 设置页面的内容区域 -->
    <div class="config_main_manage_page_wraper">
      <div class="config_main_manage_page_content">
        <!-- 设置页面  内容区域样式   以上部分都是公共样式 -->

        <config-title-hang>
          <span slot="config_title_hang_ele2">所有的控制类型</span>
        </config-title-hang>

        <!-- 服务器返回的所有场景列表 -->
        <config-hang v-for="(value, index) in serveControlTypeListData" :key="index"
          @click.native="selectSceneBtnHandle(value)" :selectState="selectButton.buttonId === value.buttonId">
          <span slot="config_hang_ele2">{{ value.buttonName }}</span>
          <img slot="config_hang_weixuan" src="~assets/img/config/weixuan.png" alt />
          <img slot="config_hang_xuanzhong" src="~assets/img/config/xuanzhong.png" alt />
        </config-hang>

        <div class="xiaotishi_style"> 小提示:仅当面板关联的主机为边界主机时,才支持跨主机控制单设备(通断,调光,电机).</div>

        <div class="public_config_que_ren_btn" @click="saveReturnBtnHandle">
          保存并返回
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import topNav from 'components/common/topnav/topnav'
import topNavItem from 'components/common/topnav/topnavitem'
import configHang from 'components/common/config/config-hang'
import configTitleHang from 'components/common/config/config-title-hang'
import { mediumslateblue } from 'color-name'

export default {
  data() {
    return {
      serveControlTypeListData: {
        ///服务器返回的控制类型数据
      },
      ServeOneObjectinfo: {
        ////一个对象的信息
      },
      selectButton: {
        buttonCode: '',
        buttonId: 0,
        buttonName: ''
      } ////选中的ID
    }
  },
  components: {
    topNav,
    topNavItem,
    configHang,
    configTitleHang
  },
  methods: {
    selectSceneBtnHandle(value) {
      console.log('111111')
      this.selectButton.buttonId = value.buttonId
      this.selectButton.buttonCode = value.buttonCode
      this.selectButton.buttonName = value.buttonName
      console.log(this.selectButton.buttonId)
    },
    saveReturnBtnHandle() {
      ///保存并返回按钮点击了
      if (this.selectButton.buttonCode === '') {
        this.$toast('请至少选择一个类型！')
        return
      }
      ////提交选中的信息并返回
      this.ServeOneObjectinfo.buttonCode = this.selectButton.buttonCode
      this.ServeOneObjectinfo.buttonId = this.selectButton.buttonId
      this.ServeOneObjectinfo.buttonName = this.selectButton.buttonName

      ////清空选中的对象 及状态
      this.ServeOneObjectinfo.businessId1 = ''
      this.ServeOneObjectinfo.businessId1Desc = ''
      this.ServeOneObjectinfo.businessState1 = ''

      this.ServeOneObjectinfo.businessId2 = ''
      this.ServeOneObjectinfo.businessId2Desc = ''
      this.ServeOneObjectinfo.businessState2 = ''

      this.$router.go(-1)
    }
  },
  created() {
    console.log('created阶段')
    this.ServeOneObjectinfo = this.$store.state.configinfo.ServeOneObjectinfo ////一个对象的地址信息拿过来
    ////拿到已经选中的信息
    this.selectButton.buttonCode = this.ServeOneObjectinfo.buttonCode
    this.selectButton.buttonId = this.ServeOneObjectinfo.buttonId
    this.selectButton.buttonName = this.ServeOneObjectinfo.buttonName
    console.log(this.ServeOneObjectinfo)
    ///获取设备按钮列表(触发类型)接口，获取数据
    this.$request({
      method: 'post',
      url: '/device/findDeviceButton',
      data: {
        token: this.$store.state.token,
        deviceId: this.ServeOneObjectinfo.deviceId
      }
    })
      .then(res => {
        if (res.data.code != 0) {
          this.$showTipsToast(3, res.data.message)
          ////说明信息填写错误,控制失败了，
          return
        } else {
          ////、控制成功了
          this.serveControlTypeListData = res.data.data ////拿到服务器返回的数据结果
          // this.$showTipsToast(1, "获取成功", true); ////提示框
        }
      })
      .catch(error => {
        console.log(error)
      })
  }
}
</script>

<style></style>
